import React, { useEffect, useState } from 'react';
import config from 'config';
import { useLocation } from 'react-router-dom';
import HeaderWrapper from './HeaderWrapper';

const Header = () => {
  const [logo, setLogo] = useState(null);
  const { pathname } = useLocation();
  const refId = pathname.split('/')[pathname.split('/').length - 1];

  useEffect(() => {
    if (
      pathname.split('/').includes('garage-validation') ||
      pathname.split('/').includes('confirmation')
    ) {
      const fetchLogo = async () => {
        try {
          const result = await fetch(`${config.managerUrl}/mediaCheck/getBrandLogo/${refId}`);
          const data = await result.json();
          if (data.brandLogo) setLogo(data.brandLogo);
          else setLogo('/assets/images/aag-logo.png');
        } catch (error) {
          setLogo('/assets/images/aag-logo.png');
        }
      };

      fetchLogo();

      return;
    }

    if (pathname.split('/').includes('quotation')) {
      const fetchLogo = async () => {
        try {
          const result = await fetch(`${config.managerUrl}/mediaCheck/getBrandLogo/${refId}`);
          const data = await result.json();
          if (data.brandLogo) setLogo(data.brandLogo);
          else setLogo('/assets/images/aag-logo.png');
        } catch (error) {
          setLogo('/assets/images/aag-logo.png');
        }
      };

      fetchLogo();
    } else {
      setLogo('/assets/images/aag-logo.png');
    }
  }, []);

  return (
    logo && (
      <HeaderWrapper>
        <img src={logo} alt="logo" />
      </HeaderWrapper>
    )
  );
};

export default Header;
